import "./Role.scss";
import React from "react";
import { useTranslation } from "react-i18next";

function Role(props) {
  const { t } = useTranslation();

  return (
    <span
      className={
        props.role == "admin"
          ? `${props.style} my-badge-admin`
          : props.role == "supervisor"
          ? `${props.style} my-badge-supervisor`
          : props.role == "call_center"
          ? `${props.style} my-badge-callCenter`
          : props.role == "finance"
          ? `${props.style} my-badge-finance`
          : props.role == "support"
          ? `${props.style} my-badge-support`
          : ""
      }
    >
      {t("role_" + props.role)}
    </span>
  );
}

export default Role;
